export const GET_EMPLOYEES_STATUS = 'GET_EMPLOYEES_STATUS';
export const GET_EMPLOYEES_ON_TIME = 'GET_EMPLOYEES_ON_TIME';
export const GET_EMPLOYEES_CLOCK_IN = 'GET_EMPLOYEES_CLOCK_IN';
export const GET_EMPLOYEES_ATTENDANCE = 'GET_EMPLOYEES_ATTENDANCE';
